import AddButton from "components/Button/AddButton";
import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownStatusList, EmptyString, FormTypeAdd, PageSize, PageTypeCount, PageTypeGetPaged, PaginationBack, PaginationFirst, PaginationLast, PaginationNext } from "utils/Constant";
import { ApiDeleteBank, ApiDeleteVendor, ApiGetBankList, ApiGetBookingList, ApiGetVendor, ApiGetVendorList, ApiInsertVendor, ApiUpdateVendor } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import EditIcon from "assets/icon/EditIcon";
import PaginationButton from "components/Input/PaginationButton";
import SearchButton from "components/Button/SearchButton";
import Dropdown from "components/Input/Dropdown";
import moment from "moment";
import { GetStatus } from "utils/helpers";
import SaveButton from "components/Button/SaveButton";

export default function Vendor(){
    let navigate = useNavigate()

    const { data: vendorList, fetch: getVendorList } = useFetch(ApiGetVendorList)
    const { fetch: insertVendor } = useFetch(ApiInsertVendor)
    const { fetch: updateVendor } = useFetch(ApiUpdateVendor)
    const { fetch: deleteVendor } = useFetch(ApiDeleteVendor)

    const { data: bankList, fetch: getBankList } = useFetch(ApiGetBankList)
    const { fetch: getBankCount } = useFetch(ApiGetBankList)
    const { fetch: deleteBank } = useFetch(ApiDeleteBank)

    const { data: bookingList, fetch: getBookingList } = useFetch(ApiGetBookingList)

    const [bankCode, setBankCode] = useState(EmptyString)
    const [bankName, setBankName] = useState(EmptyString)
    const [bookingCode, setBookingCode] = useState(EmptyString)
    const [tenantName, setTenantName] = useState(EmptyString)
    const [roomNumber, setRoomNumber] = useState(EmptyString)
    const [accMonth, setAccMonth] = useState(EmptyString)
    const [accYear, setAccYear] = useState(EmptyString)
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [vendorName, setVendorName] = useState(EmptyString)
    const [vendorId, setVendorId] = useState(EmptyString)
    const [filterVendorName, setFilterVendorName] = useState(EmptyString)

    // Dropdown
    const [statusOptions, setStatusOptions] = useState(DropdownStatusList)
    const [accMonthOptions, setAccMonthOptions] = useState([])
    const [accYearOptions, setAccYearOptions] = useState([])

    // Grid
    const[paginationOptions, setPaginationOptions] = useState([])
    const[pageIndex, setPageIndex] = useState("")
    const[totalPageCount, setTotalPageCount] = useState(0)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState(false)
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        setLoading(true)

        fGetVendorList().then(() => {
            setLoading(false)
        })
    },[])

    

    // Function Api Call
    async function fGetBankList(index){
        await getBankList({
            data: {
                bankCode: bookingCode,
                bankName: tenantName,
                status: status,
                pageSize: PageSize,
                pageIndex: parseInt(index),
                pageType: PageTypeGetPaged,
                sortBy: "A.BankCode",
                sortOrder: "ASC"
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        }).finally(() => {
        })
    }
    async function fGetBankCount(){
        let dataCount = 0

        await getBankCount({
            data: {
                bankCode: bankCode,
                bankName: bankName, 
                status: status,
                pageSize: PageSize,
                pageIndex: 0,
                pageType: PageTypeCount,
                sortBy: "A.BankCode",
                sortOrder: "ASC"
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                dataCount = response.data.dataCount
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })

        return dataCount
    }
    async function fDeleteBank(bankId){
        await deleteBank({
            data: {
                bankId: bankId,
                updateId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { setSuccessModal({  isOpen: false }) }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    async function fGetVendorList(){
        await getVendorList({
            data: {
                vendorName: filterVendorName,
                status: status,
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fInsertVendor(){
        await insertVendor({
            data: {
                vendorName: vendorName,
                updateId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                            setSuccessModal({ isOpen: false }) 
                            fClearAll()
                        }} 
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fDeleteVendor(vendorId){
        await deleteVendor({
            data: {
                vendorId: vendorId,
                updateId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                            setSuccessModal({ isOpen: false })
                        }
                    } 
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    // Function Button
    function fSaveBtnClick(){
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })
                    setLoading(true)

                    fInsertVendor().then(() => {
                        fGetVendorList()
                    }).finally(() => {
                        setLoading(false)
                    })
                }
            }
        })
    }
    function fEditBtnClick(bankId){
        //navigate("/bank/form?bankId=" + bankId + "&formType=Edit")
    }
    function fDeleteBtnClick(vendorId){
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })
                    setLoading(true)

                    fDeleteVendor(vendorId).then(() => {
                        fGetVendorList()
                    }).finally(() => {
                        setLoading(false)
                    })
                }
            }
        })
    }
    function fSearchBtnClick(){
        fGetVendorList()
    }
    function fClearAll(){
        setVendorName(EmptyString)
    }

    // Function Grid
    async function fBindGrid(index){
        setLoading(true)

        let totalData = await fGetBankCount()

        let i = index !== null ? (index !== "" ? parseInt(index) : 0) : 0

        fSetPaginationOptions(totalData, index)
        fGetBankList(i).then(() => {
            setLoading(false)
        })      
    }
    function fSetPaginationOptions(dataCount, index){
        let numberOfPage = parseInt(parseInt(dataCount)/PageSize)
        let array = []
        
        setTotalPageCount(numberOfPage = 0 ? 1 : numberOfPage)

        for (let i = 0; i <= numberOfPage; i++){
            array.push({
                label: String(i + 1),
                value: String(i)
            })
        }
        
        setPaginationOptions(array)
        
        if(index !== "" && index !== null){
            setPageIndex(String(index))
        }else{
            setPageIndex("0")
        }
    }

    function fEnterKeyDown(e){
		if(e.key === 'Enter'){
			fBindGrid(0)
		}
	}

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">Vendor</span>
            </div>
            <hr />

            <div className="border rounded p-4 bg-white">
                <div className="">
                    <h1 className="font-bold text-xl">Vendor Form</h1>
                </div>
                <hr />
                <div className="flex flex-col gap-4 mt-4">
                    <div className="flex items-center">
                        <div className="w-48">
                            <span>Vendor Id</span>
                        </div>
                        <div className="px-4">
                            <span>:</span>
                        </div>
                        <div className="w-72">
                            <input className="input" value={vendorId} disabled={true} />
                        </div>
                    </div>

                    <div className="flex items-center">
                        <div className="w-48">
                            <span>Vendor Name</span>
                        </div>
                        <div className="px-4">
                            <span>:</span>
                        </div>
                        <div className="w-72">
                            <input className="input" value={vendorName} onChange={(e) => { setVendorName(e.target.value) }} />
                        </div>
                    </div>

                    <div className="w-full flex justify-end">
                        <SaveButton visible={true} onClick={() => { fSaveBtnClick() }} />
                    </div>
                </div>
            </div>

            <div className="bg-white p-4 border rounded">
                <div className="flex flex-col sm:flex-row gap-5 justify-between mt-5 ">
                    <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                        <div className="flex flex-col gap-2 w-full sm:w-72">
                            <span>Vendor Name</span>
                            <input className="input" value={ filterVendorName } onChange={(e) => { setFilterVendorName(e.target.value) }} onKeyDown={(e) => { fEnterKeyDown(e) }} />
                        </div>
                        <div className="flex flex-col gap-2 w-full sm:w-72">
                            <span>Status</span>
                            <Dropdown value={ status } options={ statusOptions } onChange={(e) => { setStatus(e.value) }} placeholder={"All"} />
                        </div>
                    </div>
                    <div>
                        <div className="flex justify-end items-end h-full">
                            <SearchButton onClick={() => { fSearchBtnClick() }} />
                        </div>
                    </div>
                </div>
            
                <div className="mt-5">
                    <table className="w-full border bg-white">
                        <thead>
                            <tr className="h-12">
                                <th className="font-semibold w-16">No</th>
                                <th className="font-semibold text-left px-2 hidden sm:table-cell">Vendor Name</th>
                                <th className="font-semibold text-left px-2 hidden sm:table-cell">Status</th>
                                <th className="font-semibold sm:w-24">Action</th>
                            </tr>
                        </thead>
                        <tbody className="border">
                            {vendorList?.data?.map((data, i) => {
                                return(
                                    <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                        <td className="text-center">{ data.rowNumber }</td>
                                        <td className="px-2 hidden sm:table-cell">
                                            <span>{ data.vendorName }</span>
                                        </td>
                                        <td className="px-2 hidden sm:table-cell">
                                            <span>{ GetStatus(data.status) }</span>
                                        </td>
                                        <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                            <button className="button flex gap-2" onClick={() => fEditBtnClick( data.bankId )}>
                                                <EditIcon className="w-4 fill-white" />
                                            </button>
                                            <button className={`button flex gap-2 ${ data.status === "2" ? "hidden" : "block" }`} onClick={() => fDeleteBtnClick( data.bankId )}>
                                                <TrashIcon className="w-4 fill-white" />
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            
{/* 
            <PaginationButton btnFirstClick={() => { fPaginationBtnClick(PaginationFirst) }} btnBackClick={() => { fPaginationBtnClick(PaginationBack) }} 
                options={paginationOptions} value={pageIndex} onChange={(e) => { fPaginationIndexChange(e.value) }} btnNextClick={() => { fPaginationBtnClick(PaginationNext) }}
                btnLastClick={() => { fPaginationBtnClick(PaginationLast) }}
            /> */}

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading ? (<LoadingModal />) : (<div />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}